import React from 'react'
import Page from '../../layouts/Page'
import Container from './Container'
import { FormattedMessage, useIntl } from 'react-intl'

const FavoriteInfluencers = () => {
  const intl = useIntl()

  return (
    <Page
      title={<FormattedMessage id="favorites_my_list" defaultMessage={"Favorites: My Lists"} />}
      description={intl.formatMessage({ id: "favorites_my_list_desc", defaultMessage: "Save your most strategic creators for quick access during campaigns." })}
      breadcrumbs={[
        {
          title: <FormattedMessage id="influencee" defaultMessage={"influencee"} />,
          link: "/"
        },
        {
          title: <FormattedMessage id="favorites_my_list" defaultMessage={"Favorites: My Lists"} />,
          link: "/favorite-influencers"
        },
        
      ]}
    >
      <Container />
    </Page>
  )
}

export default FavoriteInfluencers